<div class="script-editor-wrapper">
  <div class="script-editor">
    <mat-form-field>
      <textarea matInput [(ngModel)]="model" (change)="onChange.emit($event)" rows="4"></textarea>
    </mat-form-field>
  </div>
</div>
